import React, { useEffect } from "react";
import "./Confirmation.css";
import { Nav } from "../../../../layouts/navbar/nav";
import images from "../../../../constant/images";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Confirmation() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const user = localStorage.getItem("user");

  const language = localStorage.getItem("i18nextLng");

  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/login");
    }, 5000);

    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    if (user) {
      navigate("/home"); // or your desired route
    }
  }, [user, navigate]);

  return (
    <div
      className="flex flex-col gap-12  "
      style={{
        backgroundImage: `url(${images.golf_field})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "relative",
        height: "100vh",
      }}
    >
      <div>
        <Nav />
      </div>

      <div className="flex items-center justify-center w-full ">
        <div className="shadow-[0px_6px_20px_rgba(0,0,0,0.7)] bg-white p-4   md:p-12 rounded-xl w-full max-w-[80%] sm:max-w-[620px] text-center mt-0 md:mt-2.5">
          <div className="top">
            <h1 className="title">Confirmation</h1>
            <p className="subTitle">
              {t("confirm_waiting.registration_in_progress")}
            </p>
          </div>

          <div className="body">
            <div className="infoText">
              <p className="fText">
              {t("confirm_waiting.thank_you")}
              <strong>GTM</strong>
              </p>
              <p className="bodyText">
              {t("confirm_waiting.verification_message")}

              </p>
            </div>
            <div className="loader">
              <p className="loaderText">
                {" "}
                {t("confirm_waiting.please_wait")}
              </p>
              <div className="spinner"></div>
            </div>
          </div>

          <div className="text-[7px] xs:text-xs sm:text-[12px] text-center text-[#666] pt-[40px]">
              {t("login.help_message")} <br className="hidden xs:block" />
              {language === "fr" ? "Voir les" : "See the"}{" "}
              <NavLink
                to="/termes-et-conditions"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "Conditions d'utilisation"
                  : "Terms of Use"}
              </NavLink>
              ,{" "}
              <NavLink
                to="/conditions-de-notification"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "Conditions de notification"
                  : "Notification conditions"}
              </NavLink>
              ,{" "}
              <NavLink
                to="/conditions-de-paiement"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "Conditions de paiement"
                  : "Payment conditions"}
              </NavLink>
              {language === "fr" ? ", et la" : ", and"}{" "}
              <NavLink
                to="/politique-de-confidentialite"
                className="text-blue-500 no-underline hover:underline"
              >
                {language === "fr"
                  ? "politique de confidentialité"
                  : "Privacy Policy"}
              </NavLink>
              .
            </div>
        </div>
      </div>
    </div>
  );
}
